import { z } from 'zod'
import { Result } from '@cplug/frontend-core/utils'
import type { StandardObservation } from '../models/StandardObservations'
import {
  mapDTOToStandardObservation,
  mapStandardObservationToDTO,
  StandardObservationDTO as StandardObservationDTOSchema,
  type StandardObservationDTO
} from './DTOs/StandardObservations'
import { CPBaseCRUDGateway } from '~/shared/gateways/CPBaseCRUDGateway'

type ListDTO = { standard_observations: StandardObservationDTO[] }

export class CPERPSettingsStandardObservationGateway
  extends CPBaseCRUDGateway<StandardObservationDTO, ListDTO, StandardObservation> {
  protected apiUrlDomain = 'standard-observations'

  protected dtoToModelMapper = (dto: StandardObservationDTO): Result<StandardObservation> =>
    Result.ofValue(mapDTOToStandardObservation(dto))

  protected modelToDtoMapper = mapStandardObservationToDTO
  protected dtoSchema: z.ZodType<StandardObservationDTO> = StandardObservationDTOSchema

  protected get listField (): 'standard_observations' {
    return 'standard_observations'
  }

  protected override get modelIdField (): keyof StandardObservation {
    return 'id'
  }
}
